<template>
  <div>
    <div
      v-if="
        GET_ACCOUNT_DATA.id == 1 || has_perm('view_frequently_asked_questions')
      "
    >
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">{{ $t("search.title") }}</h3>
        </div>
        <div class="box-body">
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-4 col-md-4 col-lg-4">
              <input
                type="text"
                class="form-control"
                :placeholder="$t('search.title')"
                v-model="search.searchText"
                v-on:keyup.enter="onSearchQuestion()"
              />
            </div>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <button
                type="button"
                class="btn btn-labeled btn-success"
                @click="onSearchQuestion()"
              >
                <span class="btn-label">
                  <i class="glyphicon glyphicon-search"></i>
                </span>
                {{ $t("search.search_button") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="box box-success">
        <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">
            {{ $t("sidebar.frequentlyAskedQuestions.title") }}
          </h3>
          <button
            v-if="
              GET_ACCOUNT_DATA.id == 1 ||
                has_perm('create_frequently_asked_questions')
            "
            type="button"
            class="btn btn-labeled btn-primary pull-right"
            @click="onAddNew"
            style="margin-right: 5px;"
          >
            <span class="btn-label"> <i class="fa fa-plus"></i> </span>
            {{ $t("common.addnew") }}
          </button>
        </div>
        <div class="box-body">
          <div class="col-md-12" style="margin-top: 15px">
            <b-table
              striped
              hover
              :items="questionAndAnswerItems"
              :fields="questionAndAnswerFields"
            >
              <template #head()="scope">
                <div class="">{{ $t(scope.label) }}</div>
              </template>
              <template #cell(questionContent)="row">
                {{ spliceString(row.item.questionContent, 100) }}
              </template>
              <template #cell(answerContent)="row">
                {{ spliceString(row.item.answerContent, 100) }}
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px">
                    <li>
                      <button
                        v-if="
                          GET_ACCOUNT_DATA.id == 1 ||
                            has_perm('update_frequently_asked_questions')
                        "
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditInput(row.item)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                    </li>
                    <li style="margin-top: 5px">
                      <button
                        v-if="
                          GET_ACCOUNT_DATA.id == 1 ||
                            has_perm('delete_frequently_asked_questions')
                        "
                        class="btn btn-danger btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenDelete(row.item)"
                      >
                        <i class="glyphicon glyphicon-trash"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
            <div class="box-footer clearfix" style="display:contents;">
              <custom-paginator
                :totalItem="paginateData.totalItem"
                :currentPage="paginateData.currentPage"
                :pageSize="paginateData.pageSize"
                :totalPage="paginateData.totalPage"
                @onpaginate="onCustomPagination"
              />
            </div>
          </div>
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <!--  -->
      </div>
      <!--  -->
      <div
        class="modal fade"
        :ref="`modal-frequently-asked-questions`"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" @click="onCloseModal">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{
                  $t(
                    questionAndAnswerData.id === 0
                      ? "frequentlyAskedQuestions.addNew"
                      : "frequentlyAskedQuestions.detail"
                  )
                }}
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("frequentlyAskedQuestions.questionContent")
                    }}</label>
                    <textarea
                      class="form-control"
                      name=""
                      id=""
                      cols="30"
                      rows="3"
                      v-model="questionAndAnswerData.questionContent"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{
                      $t("frequentlyAskedQuestions.answerContent")
                    }}</label>
                    <textarea
                      class="form-control"
                      name=""
                      id=""
                      cols="30"
                      rows="8"
                      v-model="questionAndAnswerData.answerContent"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                style="background-color: #f29911;border-color: #f29911;color:#fff"
                type="button"
                class="btn btn-default pull-left"
                @click="onCloseModal"
              >
                {{ $t("common.back") }}
              </button>
              <button
                type="button"
                class="btn btn-primary pull-right"
                @click="onSaveFrequentlyAskedQuestions"
              >
                {{ $t("common.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import CustomPaginator from "@/components/CustomPaginator.vue";
import utils from "@/lib/utils";

export default {
  components: {
    "lte-modal": LTEModal,
    CustomPaginator
  },
  data: () => ({
    search: {
      searchText: null
    },
    questionAndAnswerFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "questionContent",
        label: "frequentlyAskedQuestions.questionContent"
      },
      {
        key: "answerContent",
        label: "frequentlyAskedQuestions.answerContent"
      },
      { key: "actions", label: "common.action" }
    ],
    questionAndAnswerItems: [],
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    questionAndAnswerData: {
      id: 0,
      questionContent: null,
      answerContent: null
    }
  }),
  watch: {
    GET_FREQUENTLY_ASKED_QUESTIONS_LIST_DATA: function() {
      let paginate = this.GET_FREQUENTLY_ASKED_QUESTIONS_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_FREQUENTLY_ASKED_QUESTIONS_LIST_DATA.results;
      this.questionAndAnswerItems = [];
      data.forEach((value, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          questionContent: value.question,
          answerContent: value.answer
        };
        this.questionAndAnswerItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_FREQUENTLY_ASKED_QUESTIONS_LIST_DATA"
    ])
  },
  methods: {
    spliceString: function(strText, len) {
      return utils.spliceString(strText, len);
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onAddNew: function() {
      this.questionAndAnswerData = {
        id: 0,
        questionContent: null,
        answerContent: null
      };
      this.onShowModal();
    },
    onOpenEditInput: function(data) {
      this.questionAndAnswerData = {
        id: data.id,
        questionContent: data.questionContent,
        answerContent: data.answerContent
      };
      this.onShowModal();
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_FREQUENTLY_ASKED_QUESTIONS(this.originalRecordData)
        .then(
          function() {
            this.callbackGetFrequentlyAskedQuestions();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onSearchQuestion: function() {
      this.getFrequentlyAskedQuestions(this.paginateData.currentPage);
    },
    getFrequentlyAskedQuestions: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_FREQUENTLY_ASKED_QUESTIONS_LIST(filter);
    },
    onCallbackData: async function() {
      await this.getFrequentlyAskedQuestions(1);
    },
    callbackGetFrequentlyAskedQuestions: function() {
      this.getFrequentlyAskedQuestions(this.paginateData.currentPage);
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getFrequentlyAskedQuestions(data);
    },
    onShowModal: function() {
      $(this.$refs[`modal-frequently-asked-questions`]).modal("show");
    },
    onCloseModal: function() {
      $(this.$refs[`modal-frequently-asked-questions`]).modal("hide");
    },
    onSaveFrequentlyAskedQuestions: function() {
      if (utils.isEmptyString(this.questionAndAnswerData.questionContent)) {
        //
      } else if (utils.isEmptyString(this.questionAndAnswerData.answerContent)) {
        //
      } else {
        let data = {
          id: this.questionAndAnswerData.id,
          questionContent: this.questionAndAnswerData.questionContent,
          answerContent: this.questionAndAnswerData.answerContent
        };
        if (this.questionAndAnswerData.id === 0) {
          this.CREATE_FREQUENTLY_ASKED_QUESTIONS(data)
            .then(
              function() {
                this.callbackGetFrequentlyAskedQuestions();
                this.onCloseModal();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_FREQUENTLY_ASKED_QUESTIONS(data)
            .then(
              function() {
                this.callbackGetFrequentlyAskedQuestions();
                this.onCloseModal();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      }
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_FREQUENTLY_ASKED_QUESTIONS_LIST",
      "CREATE_FREQUENTLY_ASKED_QUESTIONS",
      "UPDATE_FREQUENTLY_ASKED_QUESTIONS",
      "DELETE_FREQUENTLY_ASKED_QUESTIONS"
    ])
  },
  async mounted() {
    await this.getFrequentlyAskedQuestions(1);
  }
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 100px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/FrequentlyAskedQuestions/FrequentlyAskedQuestionsList.vue